<template>
	<div class="flex justify-center items-center h-full">
		<router-view />
	</div>
</template>

<script>
export default {};
</script>

<style></style>
